export default "__VITE_ASSET__twQq8NyB__"